import { useTranslation } from 'react-i18next';
import { BodyText } from 'vopay';
import { useAlertDialog } from '#shared/providers/AlertDialog';

// Shared by the form's Cancel button and the product switcher: both abandon unsaved branding
// changes, so both ask with the same wording.
export default function useBrandingDiscardDialog() {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Branding.Form' });
  const alertDialog = useAlertDialog();

  return async function confirmDiscard(): Promise<boolean> {
    const result = await alertDialog.caution(
      t('discardTitle', { defaultValue: 'Discard unsaved changes?' }),
      <BodyText>{t('discardBody', { defaultValue: "Your branding changes haven't been saved." })}</BodyText>,
      {
        abortLabel: t('keepEditingButton', { defaultValue: 'Keep editing' }),
        confirmLabel: t('discardButton', { defaultValue: 'Discard' }),
      },
    );

    return result === 'confirm';
  };
}
